import { render, staticRenderFns } from "./Hotlist.vue?vue&type=template&id=4c09a8ea&scoped=true&"
import script from "./Hotlist.vue?vue&type=script&lang=js&"
export * from "./Hotlist.vue?vue&type=script&lang=js&"
import style0 from "./Hotlist.vue?vue&type=style&index=0&id=4c09a8ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09a8ea",
  null
  
)

export default component.exports